/** The documentation inside the application. */
import { baseApi } from '../baseApi';
import type {
  HelpArticle,
  HelpArticleIn,
  HelpIndex,
} from '../types';

export const helpApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getHelpIndex: build.query<HelpIndex, string>({
      query: (lang) => ({ url: '/help', params: { lang } }),
      providesTags: ['Help'],
    }),
    // `exact` asks for that very language; without it the nearest one is given.
    getHelpArticle: build.query<HelpArticle, { slug: string; lang: string; exact?: boolean }>({
      query: ({ slug, lang, exact }) => ({ url: `/help/${slug}`, params: { lang, exact } }),
      providesTags: ['Help'],
    }),
    saveHelpArticle: build.mutation<
      HelpArticle,
      { slug: string; locale: string; body: HelpArticleIn }
    >({
      query: ({ slug, locale, body }) => ({ url: `/help/${slug}/${locale}`, method: 'PUT', body }),
      invalidatesTags: ['Help'],
    }),
    // Without a language, the article goes in every language.
    deleteHelpArticle: build.mutation<void, { slug: string; locale?: string }>({
      query: ({ slug, locale }) => ({
        url: locale ? `/help/${slug}/${locale}` : `/help/${slug}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Help'],
    }),
  }),
});

export const {
  useGetHelpIndexQuery,
  useGetHelpArticleQuery,
  useSaveHelpArticleMutation,
  useDeleteHelpArticleMutation,
} = helpApi;
